import React from "react";
import "./Flashing.scss";

const FlashingText = ({ children }) => {
    return (
        <div className="flashing-text">
            {children}
        </div>
    );
};

export default FlashingText;
